import {
  Grid,
  IconButton,
  IconTrashLine,
  NumberInput,
  TextInput,
} from "@instructure/ui";
import { memo, useContext } from "react";
import { useTranslation } from "react-i18next";
import { MasteryLevelContext } from "../../../utils/Context";
import { Selector } from "../../Selectors/Selector";

const RatingLevel = memo(
  ({
    index,
    ratingLevel,
    setRatingLevels,
    isCanvasDefault,
    isEditable,
    isRatingScaleMapped,
  }) => {
    const { t } = useTranslation();
    const { masteryLevels } = useContext(MasteryLevelContext);

    const handleRemove = () => {
      setRatingLevels((prevLevels) => [
        ...prevLevels.filter((_, i) => index !== i),
      ]);
    };

    const handleIncrement = () => {
      setRatingLevels((prevLevels) =>
        prevLevels.map((item, i) => {
          if (i === index) {
            return { ...item, points: Number(item.points + 1) };
          }
          return item;
        })
      );
    };

    const handleDecrement = () => {
      if (ratingLevel.points > 0) {
        setRatingLevels((prevLevels) =>
          prevLevels.map((item, i) => {
            if (i === index) {
              return { ...item, points: item.points - 1 };
            }
            return item;
          })
        );
      }
    };

    return (
      <Grid vAlign="bottom">
        <Grid.Row>
          <Grid.Col width={2}>
            <NumberInput
              id={`rating-level-points-${index}`}
              renderLabel={t("masteryLevels.points")}
              value={ratingLevel.points}
              onIncrement={handleIncrement}
              onDecrement={handleDecrement}
              onChange={(_, value) => {
                value = value ? Number(value) : "";
                if (!Number.isNaN(value)) {
                  setRatingLevels((prevLevels) =>
                    prevLevels.map((item, i) => {
                      if (i === index) {
                        return { ...item, points: value };
                      }
                      return item;
                    })
                  );
                }
              }}
              interaction={
                isCanvasDefault || !isEditable ? "disabled" : "enabled"
              }
            />
          </Grid.Col>
          <Grid.Col width={3}>
            <Selector
              id={`rating-level-mastery-level-${index}`}
              label={t("masteryLevels.masteryLevel")}
              options={masteryLevels.map((level) => ({
                id: level.id,
                label: level.level,
              }))}
              selectedItemId={ratingLevel.mastery_level_id}
              selectHandler={(value) => {
                setRatingLevels((prevLevels) =>
                  prevLevels.map((item, i) => {
                    if (i === index) {
                      return { ...item, mastery_level_id: value };
                    }
                    return item;
                  })
                );
              }}
              interaction={isEditable || !isRatingScaleMapped}
            />
          </Grid.Col>
          <Grid.Col width={6}>
            <TextInput
              id={`rating-level-description-${index}`}
              renderLabel={t("masteryLevels.ratingLevelDesc")}
              value={ratingLevel.description}
              onChange={(e) => {
                setRatingLevels((prevLevels) =>
                  prevLevels.map((item, i) => {
                    if (i === index) {
                      return { ...item, description: e.target.value };
                    }
                    return item;
                  })
                );
              }}
            />
          </Grid.Col>
          <Grid.Col width={1} textAlign="end">
            <IconButton
              renderIcon={IconTrashLine}
              onClick={handleRemove}
              interaction={
                isCanvasDefault || !isEditable ? "disabled" : "enabled"
              }
              screenReaderLabel={t("masteryLevels.deleteRatingMasteryOption")}
            />
          </Grid.Col>
        </Grid.Row>
      </Grid>
    );
  }
);

export default RatingLevel;
